import React from 'react';
import {Col, Form, Input, Row} from "antd";
import {t} from "i18next";
const InputLocation = props => {
    return (
        <Row gutter={12}>
            <Col
                xxl={{span: 16}}
                xl={{span: 16}}
                lg={{span: 16}}>
                <Form.Item
                    label={<b>{props.label}</b>}
                    name={props.name}
                    rules={[{required: props.require , message: t("tnp.setting.nameLabelRequire")}]}>
                    <Input/>
                </Form.Item>
            </Col>
        </Row>
    );
};


export default InputLocation;
